import { PBRMaterial } from "@babylonjs/core/Materials/PBR/pbrMaterial";
import { GLTFLoader } from "../glTFLoader";
var NAME = "KHR_materials_specular";
/**
 * [Proposed Specification](https://github.com/KhronosGroup/glTF/pull/1677)
 * [Playground Sample](https://www.babylonjs-playground.com/frame.html#BNIZX6#4)
 * !!! Experimental Extension Subject to Changes !!!
 */

var KHR_materials_specular =
/** @class */
function () {
  /** @hidden */
  function KHR_materials_specular(loader) {
    /**
     * The name of this extension.
     */
    this.name = NAME;
    /**
     * Defines a number that determines the order the extensions are applied.
     */

    this.order = 190;
    this._loader = loader;
    this.enabled = this._loader.isExtensionUsed(NAME);
  }
  /** @hidden */


  KHR_materials_specular.prototype.dispose = function () {
    delete this._loader;
  };
  /** @hidden */


  KHR_materials_specular.prototype.loadMaterialPropertiesAsync = function (context, material, babylonMaterial) {
    var _this = this;

    return GLTFLoader.LoadExtensionAsync(context, material, this.name, function (extensionContext, extension) {
      var promises = new Array();
      promises.push(_this._loader.loadMaterialPropertiesAsync(context, material, babylonMaterial));
      promises.push(_this._loadSpecularPropertiesAsync(extensionContext, extension, babylonMaterial));
      return Promise.all(promises).then(function () {});
    });
  };

  KHR_materials_specular.prototype._loadSpecularPropertiesAsync = function (context, properties, babylonMaterial) {
    if (!(babylonMaterial instanceof PBRMaterial)) {
      throw new Error(context + ": Material type not supported");
    }

    if (properties.specularFactor !== undefined) {
      babylonMaterial.metallicF0Factor = properties.specularFactor;
    }

    if (properties.specularTexture) {
      // This does not allow a separate sampler for it at the moment but is currently under discussion.
      babylonMaterial.useMetallicF0FactorFromMetallicTexture = true;
    }

    return Promise.resolve();
  };

  return KHR_materials_specular;
}();

export { KHR_materials_specular };
GLTFLoader.RegisterExtension(NAME, function (loader) {
  return new KHR_materials_specular(loader);
});